"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utility = require("./utility");

var _excluded = ["type"],
    _excluded2 = ["text"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var parseKeywords = function parseKeywords(keywords) {
  return keywords.filter(function (k) {
    return k.mentions;
  }).map(function (k) {
    return {
      name: k.keyword,
      score: !isNaN(k.relevance) ? k.relevance : 1,
      t: k.mentions.map(function (m) {
        var _ref;

        return _ref = {}, _ref[m.speakerName] = m.occurrences.map(function (o) {
          return o.s;
        }), _ref;
      }).reduce(function (acc, m) {
        return Object.assign(acc, m);
      }, {}),
      internalName: []
    };
  });
};

var parseUniqueSpeakersFromKeywords = function parseUniqueSpeakersFromKeywords(keywords) {
  return [].concat(keywords.filter(function (k) {
    return k.mentions;
  }).map(function (k) {
    return k.mentions.map(function (m) {
      return m.speakerName;
    });
  }).reduce(function (acc, s) {
    return acc.concat(s);
  }, []).reduce(function (acc, s) {
    return acc.add(s);
  }, new Set()));
};

var parse = function parse(data) {
  var classifiers = [];
  var detectors = [];
  var groups = [];
  var metrics = [];
  var entities = [];
  var speakers = [];
  var topics = [];
  var keyWords = [];
  var transcript = [];
  var fullTurns = [];
  var transcriptSpeakers = [];
  var transcriptCC = "";
  var interactionType = "";
  var verbArray = [];

  if (data.spotting) {
    if (data.spotting.groups) {
      groups = groups.concat(data.spotting.groups.map(function (g) {
        return {
          name: g.groupName,
          keywords: parseKeywords(g.spottedKeywords),
          speakers: parseUniqueSpeakersFromKeywords(g.spottedKeywords),
          score: 1,
          similarCategories: [],
          subcategories: [],
          type: "category"
        };
      }));
    }
  }

  if (data.knowledge) {
    if (data.knowledge.topics) {
      topics = topics.concat(data.knowledge.topics.map(function (t) {
        return {
          name: t.topicName,
          keywords: parseKeywords(t.keywords),
          speakers: parseUniqueSpeakersFromKeywords(t.keywords),
          score: t.relevance,
          similarCategories: [],
          subcategories: [],
          type: "category"
        };
      }));
    }

    if (data.knowledge.keywords) {
      topics.push({
        name: "Unsorted",
        type: "unsorted",
        keywords: parseKeywords(data.knowledge.keywords),
        speakers: parseUniqueSpeakersFromKeywords(data.knowledge.keywords)
      });
    }
  }

  if (data.transcript) {
    if (data.transcript.words) {
      var _data$transcript;

      var _parseWordsArray = (0, _utility.parseWordsArray)(data.transcript.words),
          wordsArrayWords = _parseWordsArray.words,
          wordsArraySpeakers = _parseWordsArray.speakers,
          wordsArrayTranscriptSpeakers = _parseWordsArray.transcriptSpeakers;

      transcript = transcript.concat(wordsArrayWords);
      speakers = (0, _utility.addSpeakersToSpeakerArray)(speakers, wordsArraySpeakers);
      transcriptSpeakers = wordsArrayTranscriptSpeakers;
      fullTurns = (data === null || data === void 0 ? void 0 : (_data$transcript = data.transcript) === null || _data$transcript === void 0 ? void 0 : _data$transcript.turns) || (data === null || data === void 0 ? void 0 : data.messages);
    }

    if (data.transcript.alternateFormats && data.transcript.alternateFormats.length) {
      // Only webvtt is supported, so we can ignore other formats.
      var webvttFormat = data.transcript.alternateFormats.find(function (alternateFormat) {
        return alternateFormat.format === "webvtt";
      });

      if (webvttFormat) {
        // Since HTML5 track element only supports inclusion through src, we have to
        // turn the vtt contents into a blob, then convert the blob into a DomString (think dataURI).
        transcriptCC = URL.createObjectURL((0, _utility.b64toBlob)(webvttFormat.data, webvttFormat.contentType));
      }
    }
  }

  if (data.interactionType) {
    interactionType = data.interactionType;
  }

  if (data.prediction && data.prediction.classifiers) {
    classifiers = (0, _utility.parseClassifiersArray)(data.prediction.classifiers);
  }

  if (data.metrics) {
    metrics = data.metrics; // eslint-disable-line prefer-destructuring

    metrics.forEach(function (metricGroup) {
      metricGroup.metricValues.forEach(function (metric) {
        if (metric.metricName === "call-change-in-sentiment") {
          metric.metricName = "intra-call-change-in-sentiment";
        } else if (metric.metricName === "agent-to-caller-talk-rate-ratio") {
          metric.metricName = "intra-agent-to-caller-talk-rate-ratio";
        }
      });
    });
  }

  if (data.categories) {
    var catArray = [];
    data.categories.filter(function (category) {
      return category.categoryValue;
    }).forEach(function (category, index) {
      var occurrence = {};
      var keywords = [];
      var speakers = [];
      (category.categoryMatches || []).forEach(function (val, indx) {
        var speaker = val.speakerName;
        speakers.push(speaker);
        val.occurrences.forEach(function (v, i) {
          var keyName = v.exact.split(" ").join("_");

          if (keyName in occurrence) {
            occurrence[keyName].start.push(v.s);
            occurrence[keyName].end.push(v.e);
            occurrence[keyName].hits.push({
              s: v.s,
              w: speaker
            });
          } else {
            var tempStart = [];
            var tempEnd = [];
            var tempObj = {};
            var hits = [];
            var tempHit = {};
            tempStart.push(v.s);
            tempEnd.push(v.e);
            tempHit.s = v.s;
            tempHit.w = speaker;
            hits.push(tempHit);
            tempObj.start = tempStart;
            tempObj.end = tempEnd;
            tempObj.exact = v.exact;
            tempObj.hits = hits;
            occurrence[keyName] = tempObj;
            keywords.push(v.exact);
          }
        });
      });
      catArray.push({
        name: category.categoryName,
        type: "category",
        occurrences: Object.values(occurrence),
        keywords: keywords,
        speakers: speakers
      });
    });
    catArray.forEach(function (value) {
      var keywords = [];
      value.occurrences.forEach(function (val) {
        var speaker = value.speakers[0];
        keywords.push({
          name: val.exact,
          score: 1,
          internalName: [],
          t: {
            speaker: val.start
          }
        });
      });
      value.keywords = keywords;
    });
    data.categories = catArray;
  }

  if (data.conversation) {
    data.conversation.speakerVerbNounPairs.forEach(function (category, index) {
      var occurrence = {};
      var keywords = [];
      var speakers = [category === null || category === void 0 ? void 0 : category.speakerName];
      ((category === null || category === void 0 ? void 0 : category.verbNounPairs) || []).forEach(function (val, indx) {
        var tempStart = [];
        var tempEnd = [];
        var tempObj = {};
        var hits = [];
        var tempHit = {};
        tempStart.push(val.s);
        tempEnd.push(val.e);
        tempHit.s = val.s;
        tempHit.w = category === null || category === void 0 ? void 0 : category.speakerName;
        hits.push(tempHit);
        tempObj.start = tempStart;
        tempObj.end = tempEnd;
        tempObj.hits = hits;
        verbArray.push({
          name: (val === null || val === void 0 ? void 0 : val.verb) + " " + (val === null || val === void 0 ? void 0 : val.noun),
          type: "category",
          occurrences: [tempObj],
          keywords: keywords,
          speakers: speakers
        });
      });
    });
  }

  if (data.prediction && data.prediction.detectors) {
    detectors = data.prediction.detectors.reduce(function (acc, detector) {
      return detector.detections.reduce(function (acc2, detection) {
        return detection.detectedSegments.reduce(function (acc3, s) {
          return acc3.concat({
            name: detector.detectorName,
            detector: detector.detectorId,
            "class": detection.detectorClass,
            title: detection.detectorClassLabel,
            channel: null,
            intervals: s.occurrences.map(function (_ref2) {
              var start = _ref2.s,
                  end = _ref2.e;
              return {
                start: start,
                end: end
              };
            })
          });
        }, []).concat(acc2);
      }, []).concat(acc);
    }, []);
  }

  if (data.entities) {
    var finalEntityGroup = [];
    var entityGroup = {};
    data.entities.forEach(function (entity) {
      var type = entity.type,
          rest = _objectWithoutPropertiesLoose(entity, _excluded);

      if (entityGroup[type]) {
        entityGroup[entity.type].push(rest);
      } else {
        entityGroup[entity.type] = [rest];
      }
    });
    Object.keys(entityGroup).forEach(function (key) {
      var texts = entityGroup[key];
      var groups = {};
      texts.forEach(function (_ref3) {
        var text = _ref3.text,
            rest = _objectWithoutPropertiesLoose(_ref3, _excluded2);

        if (groups[text]) {
          groups[text].push(rest);
        } else {
          groups[text] = [rest];
        }
      });
      var occurrences = Object.keys(groups).map(function (key) {
        return {
          text: key,
          occurrences: groups[key]
        };
      });
      finalEntityGroup.push({
        name: key,
        keywords: occurrences,
        type: "category"
      });
    });
    entities = finalEntityGroup;
  }

  return {
    mediaContentType: data.mediaContentType,
    mediaId: data.mediaId,
    activeTopic: 0,
    topics: topics,
    activeGroup: 0,
    groups: groups,
    activeSpeaker: 0,
    speakers: speakers,
    transcriptSpeakers: transcriptSpeakers,
    transcript: transcript,
    fullTurns: fullTurns,
    interactionType: interactionType,
    transcriptCC: transcriptCC,
    classifiers: classifiers || [],
    verbs: verbArray || [],
    metrics: metrics || [],
    categories: data.categories || [],
    detectors: detectors || [],
    speakerSentiments: data.speakerSentiments || [],
    metadata: {
      contentType: data.mediaContentType,
      detail: data.metadata
    },
    entities: entities
  };
};

var _default = parse;
exports["default"] = _default;